var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWireRoll(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "mit_bl._Kreislinie",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 150 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2,.cls-3,.cls-4,.cls-5,.cls-6{fill:none;}.cls-1,.cls-3,.cls-5,.cls-6{stroke:#009fe3;}.cls-7{fill:#009fe3;}.cls-3{stroke-width:4px;}.cls-3,.cls-6{stroke-linecap:round;}.cls-4{clip-path:url(#clippath);}.cls-5{stroke-width:3px;}.cls-6{stroke-width:7px;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 0,
    y: 0,
    width: 150,
    height: 150
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Kabeltrommel"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 75,
    cy: 75,
    r: 68.88
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 58.43,
    y: 49.8,
    width: 3.35,
    height: 51.38
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 58.43,
    y: 49.8,
    width: 3.35,
    height: 51.38
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 89.23,
    y: 49.8,
    width: 3.35,
    height: 51.38
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 89.23,
    y: 49.8,
    width: 3.35,
    height: 51.38
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 65.16,
    y1: 54.68,
    x2: 65.16,
    y2: 96.38
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 70.47,
    y1: 54.68,
    x2: 70.47,
    y2: 96.38
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 75.77,
    y1: 54.68,
    x2: 75.77,
    y2: 96.38
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 54.09,
    y1: 43.44,
    x2: 54.09,
    y2: 107.49
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 96.93,
    y1: 43.44,
    x2: 96.93,
    y2: 107.49
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 80.7,
    y1: 54.68,
    x2: 80.7,
    y2: 96.38
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 86.01,
    y1: 54.68,
    x2: 86.01,
    y2: 120.95
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWireRoll);
export default __webpack_public_path__ + "static/media/wire-roll.c2b6586e05dd299e9ae6c9f04fab555c.svg";
export { ForwardRef as ReactComponent };